import React from 'react';
import { useTranslation } from 'react-i18next';

export const ServiceSection = ({ serviceItems, activeServiceId, setActiveServiceId, activeServiceItem }) => {
  const { t } = useTranslation();

  return (
    <div class="vb-content-normal vb-content-normal--service">
      <div class="container vb-home-content vb-service-shell">
        <div class="row">
          <div class="col-lg-12">
            <h5 class="vb-about-subtitle-center">{t('home.service.title')}</h5>
          </div>
        </div>
        <div class="vb-service-tabs" role="tablist" aria-label={t('home.service.aria')}>
          {serviceItems.map((serviceItem) => (
            <button
              key={serviceItem.id}
              type="button"
              class={`vb-service-tab ${activeServiceId === serviceItem.id ? 'vb-service-tab--active' : ''}`}
              onClick={() => setActiveServiceId(serviceItem.id)}
              role="tab"
              aria-selected={activeServiceId === serviceItem.id}
            >
              {serviceItem.label}
            </button>
          ))}
        </div>
        <div class="vb-service-stage">
          <div class="vb-service-stage-media">
            {activeServiceItem && <img class="vb-service-stage-image" src={activeServiceItem.image} alt={activeServiceItem.alt}></img>}
          </div>
          <div class="vb-service-stage-content">
            <h1 class="vb-service-stage-title">{activeServiceItem?.title || ''}</h1>
            <p class="vb-service-stage-body">{activeServiceItem?.body || ''}</p>
            <ul class="vb-service-stage-list">
              {(activeServiceItem?.bullets || []).map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
